"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _queryString = _interopRequireDefault(require("query-string"));
var _basic = _interopRequireDefault(require("./_basic"));
const getErrorMessage = e => {
  const responseData = _lodash.default.get(e, 'response.data');
  const errorMessage = _lodash.default.get(e, 'message');
  const responseError = _lodash.default.get(responseData, 'error', responseData);
  return _lodash.default.isString(responseError) ? responseError : _lodash.default.isEmpty(responseError) ? errorMessage : JSON.stringify(responseError);
};
class TablesApi extends _basic.default {
  /**
   * Represents a Tables Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      tablesApiUrl,
      accountId,
      userId,
      timeout
    } = _ref;
    super({
      userTokenFactory
    });
    this.tablesApiUrl = tablesApiUrl;
    this.accountId = accountId;
    this.userId = userId;
    this.axios = _axios.default.create({
      ...(timeout && {
        timeout
      })
    });
  }
  getUrl(url, publicRoute) {
    return publicRoute ? `${this.tablesApiUrl}/${url}` : `${this.tablesApiUrl}/${this.accountId()}/${this.userId()}/${url}`;
  }
  async _callApi(_ref2) {
    let {
      url,
      data,
      method,
      publicRoute
    } = _ref2;
    const {
      data: responce
    } = await this.axios({
      url: this.getUrl(url, publicRoute),
      method,
      data,
      headers: {
        Authorization: this.userToken,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).catch(e => {
      throw new Error(getErrorMessage(e));
    });
    return responce;
  }

  /**
   * @returns statistics about indexes, limits and total size
   */
  async getIndexesStatistics() {
    return this._callApi({
      url: 'indexes-statistics'
    });
  }

  /**
   * 
   * @param {String} index name of table name
   * @returns {Array} of filters
   */
  async getFilters(index) {
    return this._callApi({
      url: `filters?${_queryString.default.stringify({
        index
      })}`
    });
  }

  /**
   * 
   * @param {Array} param0.filters array of filters
   * @param {String} param0.index name of table
   */
  async saveFilters(_ref3) {
    let {
      filters,
      index
    } = _ref3;
    return this._callApi({
      method: 'put',
      url: 'filters',
      data: {
        filters,
        index
      }
    });
  }

  /**
  * 
  * @returns {Array} of saved sql queries
  */
  async getQueries() {
    const {
      _source: {
        queries
      }
    } = await this._callApi({
      url: `sql-queries`
    });
    return queries;
  }

  /**
   * 
   * @param {Array} param0.queries array of sql queries
   */
  async saveQueries(_ref4) {
    let {
      queries
    } = _ref4;
    return this._callApi({
      method: 'put',
      url: 'sql-queries',
      data: {
        queries
      }
    });
  }

  /**
   * 
   * @param {String} param0.messageId id of message to verify
   * @param {String} param0.type type of message  
   */
  async checkProgress(_ref5) {
    let {
      messageId,
      type
    } = _ref5;
    return this._callApi({
      url: `check-progress?${_queryString.default.stringify({
        messageId,
        type
      })}`
    });
  }

  /**
   * 
   * @param {String} index name of table
   * @param {Object} mappings mappings to add
   */
  async addColumns(index, mappings) {
    return this._callApi({
      method: 'post',
      url: 'mappings',
      data: {
        index,
        mappings
      }
    });
  }

  /**
   * 
   * @param {String} param0.index name of table
   * @param {Object} param.mappings mappings object
   */
  async createTable(_ref6) {
    let {
      index,
      mappings
    } = _ref6;
    return this._callApi({
      method: 'post',
      url: 'rows',
      data: {
        index,
        mappings,
        create: true,
        rows: []
      }
    });
  }

  /**
   * 
   * @param {String} param0.index name of table 
   * @param {String} param.extension csv or json extension of file
   * @param {Object} param0.query query to export rows
   */
  async exportTable(_ref7) {
    let {
      index,
      extension,
      query
    } = _ref7;
    return this._callApi({
      method: 'post',
      url: 'export',
      data: {
        index,
        extension,
        query
      }
    });
  }

  /**
   * 
   * @param {String} param0.fileURL url to file
   * @param {String} param0.index name of table
   * @param {String} param0.encoding file encoding. default utf-8
   * @param {Boolean} param0.create table or import to existing 
   * @param {Object} param0.mapColumns columns to use
   */
  async importFile(_ref8) {
    let {
      fileURL,
      index,
      create,
      mapColumns,
      encoding
    } = _ref8;
    return this._callApi({
      method: 'post',
      url: 'process-file',
      data: {
        index,
        fileURL,
        create,
        mapColumns,
        encoding
      }
    });
  }

  /**
   * 
   * @param {Boolean} param0.create create table
   * @param {Array} param0.rows rows to insert
   * @param {String} param0.index name of table
   * @param {Object} param0.mapColumns columns to use  
   * @param {Boolean} param.returnRows return ids of inserted rows
   * @param {String} param.refresh ["wait_for", "true", "false"] default wait_for. false if docs not needed to be visible, works much faster
   */
  async insertRows(_ref9) {
    let {
      create,
      rows,
      index,
      mapColumns,
      returnRows,
      refresh
    } = _ref9;
    return this._callApi({
      method: 'post',
      url: 'rows',
      data: {
        create,
        rows,
        index,
        mapColumns,
        returnRows,
        refresh
      }
    });
  }

  /**
   * 
   * @param {String} param0.index name of table
   * @param {Array} param0.ids array of rows to delete
   * @param {String} param.refresh ["wait_for", "true", "false"] default wait_for. false if docs not needed to be visible, works much faster
   */
  async deleteRows(_ref10) {
    let {
      index,
      ids,
      refresh
    } = _ref10;
    return this._callApi({
      method: 'delete',
      url: 'rows',
      data: {
        index,
        ids,
        refresh
      }
    });
  }

  /**
   * 
   * @param {String} fileName name of file to import 
   */
  async uploadFile(fileName) {
    return this._callApi({
      method: 'post',
      url: 'upload-file',
      data: {
        fileName
      }
    });
  }

  /**
   * 
   * @param {String} param0.script script to modify rows
   * @param {String} param0.index name of table
   * @param {String} param0.target name of new table
   * @param {Object} param0.mappings columns in new table
   *
   */
  async reindex(_ref11) {
    let {
      script,
      index,
      target,
      mappings
    } = _ref11;
    return this._callApi({
      method: 'post',
      url: 'reindex',
      data: {
        script,
        index,
        mappings,
        target
      }
    });
  }

  /**
   * 
   * @param {String} task id of reindex task 
   */
  async checkReindexStatus(task) {
    return this._callApi({
      url: `reindex?${_queryString.default.stringify({
        task
      })}`
    });
  }

  /**
   * 
   * @param {String} index name of table 
   */
  async getMappings(index) {
    return this._callApi({
      url: `mappings?${_queryString.default.stringify({
        index
      })}`
    });
  }

  /**
   * 
   * @param {String} param0.index name of table 
   * @param {Number} param0.from skip rows 
   * @param {Number} param0.size limit response size
   * @param {String} param0.sort sort by comma separated string
   * @param {Object} param0.query query to select rows
   * @param {Object} param0.query aggs to aggregate result
   * @param {String} param0.scroll for example 30s time when scroll will be alive to search with pages
   * @param {String} param0._source string | string[] - True or false to return the _source field or not, or a list of fields to return
   */
  async findRows(_ref12) {
    let {
      index,
      from,
      size,
      sort,
      query,
      scroll,
      _source,
      aggs
    } = _ref12;
    return this._callApi({
      url: `rows?${_queryString.default.stringify({
        index,
        from,
        size,
        ...(sort && {
          sort
        }),
        ...(!_lodash.default.isEmpty(query) && {
          query: JSON.stringify(query)
        }),
        ...(!_lodash.default.isEmpty(aggs) && {
          aggs: JSON.stringify(aggs)
        }),
        scroll,
        _source
      })}`
    });
  }
  /**
   * 
   * @param {String} param0.scroll_id id of scroll that was given in findRows method
   * @param {String} param0.scroll for example 30s time when scroll will be alive to search with pages
   */
  async scroll(_ref13) {
    let {
      scroll_id,
      scroll
    } = _ref13;
    return this._callApi({
      url: `scroll?${_queryString.default.stringify({
        scroll_id,
        scroll
      })}`
    });
  }
  /**
   * 
   * @param {String} param0.index name of table 
   * @param {Number} param0.from skip rows 
   * @param {Number} param0.size limit response size
   * @param {String} param0.sort sort by comma separated string
   * @param {Object} param0.query query to select rows
   * @param {String} param0._source string | string[] - True or false to return the _source field or not, or a list of fields to return
   */
  async findAllRows(_ref14) {
    let {
      index,
      from,
      size,
      sort,
      query,
      _source
    } = _ref14;
    let hits = [];
    const data = await this.findRows({
      index,
      from,
      size,
      sort,
      query,
      scroll: '30s',
      _source
    });
    hits = data.hits.hits;
    let scroll_id = data._scroll_id;
    while (scroll_id) {
      const scroll = await this.scroll({
        scroll_id,
        scroll: '30s'
      });
      hits = hits.concat(scroll.hits.hits);
      scroll_id = scroll.hits.hits.length ? scroll._scroll_id : false;
    }
    return hits.map(hit => _lodash.default.omit(hit, ['_index', '_type']));
  }

  /**
   * 
   * @param {String} param0.index table name
   * @param {Array} param0.rows   array of rows to update
   * @param {String} param.refresh ["wait_for", "true", "false"] default wait_for. false if docs not needed to be visible, works much faster
   */
  async updateRows(_ref15) {
    let {
      index,
      rows,
      refresh
    } = _ref15;
    return this._callApi({
      method: 'put',
      url: 'rows',
      data: {
        index,
        rows,
        refresh
      }
    });
  }

  /**
   * 
   * @param {String} index table name 
   */
  async deleteTable(index) {
    return this._callApi({
      method: 'delete',
      url: 'indexes',
      data: {
        index
      }
    });
  }

  /**
   * 
   * @param {String} param0.index table name 
   * @param {Object} param0.query query to delete rows
   * @param {Boolean} param.refresh [true, false] default true. false if docs not needed to be visible, works much faster
   */
  async deleteByQuery(_ref16) {
    let {
      index,
      query,
      refresh
    } = _ref16;
    return this._callApi({
      method: 'delete',
      url: 'rows-by-query',
      data: {
        index,
        query,
        refresh
      }
    });
  }

  /**
   * 
   * @param {String} param0.index table name
   * @param {Object} param0.query query to find rows
   * @param {String} param0.script elasticsearch script to update rows
   * @param {Boolean} param.refresh [true, false] default true. false if docs not needed to be visible, works much faster
   */
  async updateByQuery(_ref17) {
    let {
      index,
      query,
      script,
      refresh
    } = _ref17;
    return this._callApi({
      method: 'post',
      url: 'rows-by-query',
      data: {
        index,
        query,
        script,
        refresh
      }
    });
  }

  /**
   * 
   * @param {String} param0.query sql query
   * @param {String} param0.cursor cursor for getting next page 
   * @param {String} param0.format output format: jdbc, csv, json. only jdbc supports cursor and lets to get more than 200 rows 
   *  
   */
  async runPaginatedSQL(_ref18) {
    let {
      query,
      cursor,
      format = 'jdbc'
    } = _ref18;
    return this._callApi({
      method: 'post',
      url: 'sql',
      data: {
        query,
        cursor,
        format
      }
    });
  }

  /**
   * 
   * @param {Object} response object from sql query 
   */
  // eslint-disable-next-line class-methods-use-this
  entitiesToArray(_ref19) {
    let {
      datarows,
      schema
    } = _ref19;
    return datarows.map(row => {
      const item = {};
      row.forEach((i, key) => {
        const colName = schema[key].alias || schema[key].name;
        item[colName] = i;
      });
      return item;
    });
  }

  /**
   * 
   * @param {String} param0.query sql query
   *  
   */
  async runSQL(_ref20) {
    let {
      query
    } = _ref20;
    let data = await this.runPaginatedSQL({
      query
    });
    const {
      schema
    } = data;
    let results = this.entitiesToArray(data);
    while (data.cursor) {
      data = await this.runPaginatedSQL({
        query,
        cursor: data.cursor
      });
      results = results.concat(this.entitiesToArray({
        ...data,
        schema
      }));
    }
    return results;
  }
  /**
   * 
   * @returns empty array if no snapshots are in progress now or array with items describing current running snapshots 
   */
  async checkCurrentSnapshotStatus() {
    return this._callApi({
      method: 'get',
      url: 'snapshot-status',
      publicRoute: true
    });
  }
}
var _default = TablesApi;
exports.default = _default;